class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-link');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


  document.addEventListener("DOMContentLoaded", function () {
    function updateProgressBar(cartData) {
      const progressBar = document.getElementById("cart-progress-fill");
      const remainingAmountText = document.getElementById("remaining-amount");
      const goalDot = document.querySelector(".goal-dots");

      if (!progressBar || !remainingAmountText || !goalDot) return; // Prevent errors if elements are missing

      const goal1 = 150; // Free shipping goal in dollars
      const goal2 = 300; // Second reward threshold
      const cartTotal = cartData ? cartData.total_price / 100 : 0; // Convert cents to dollars

      let remainingAmount = goal1 - cartTotal;
      let remainingAmount2 = goal2 - cartTotal;
      remainingAmount = remainingAmount > 0 ? remainingAmount.toFixed(2) : 0;
      remainingAmount2 = remainingAmount2 > 0 ? remainingAmount2.toFixed(2) : 0;

      let progress = (cartTotal / goal2) * 100;
      progress = progress > 100 ? 100 : progress;

      progressBar.style.width = progress + "%";

      // Update message based on cart total
      if (cartTotal >= goal2) {
        remainingAmountText.textContent = "Congratulations! 🎊 You’ve unlocked FREE shipping, AND your bonus gift!";
      } else if (cartTotal >= goal1) {
        remainingAmountText.innerHTML = "Nice! You’ve unlocked FREE shipping + a 10-pack of hand warmers! 🎁 " + `<br> Don’t stop now! Spend $${remainingAmount2}` + " more to unlock your bonus gift — a choice of a single product + FREE shipping! 🎉 " ;
      } else {
        remainingAmountText.textContent = `You’re just $${remainingAmount} away from unlocking a free gift + free shipping! 🎁`;
      }

      // Adjust dot position and color
      let goal1Position = (goal1 / goal2) * 100; // 50% of total progress bar
      goalDot.style.left = goal1Position + "%";

      if (cartTotal >= goal1) {
        goalDot.style.background = "#9b1c2e"; // Filled when goal is reached
      } else {
        goalDot.style.background = "white"; // Hollow before goal is reached
      }
    }

    function fetchAndUpdateProgressBar() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(data => updateProgressBar(data))
        .catch(error => console.error("Error updating progress bar:", error));
    }

    // Listen for Shopify's AJAX cart updates
    document.addEventListener("cart:updated", fetchAndUpdateProgressBar);

    // Also trigger update after the cart is modified via AJAX
    const observer = new MutationObserver(fetchAndUpdateProgressBar);
    observer.observe(document.getElementById('CartDrawer'), { childList: true, subtree: true });

    // Initial check when the cart drawer opens (to prevent delay)
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => updateProgressBar(data)) // Update instantly with existing cart data
      .catch(error => console.error("Error fetching initial cart data:", error));
  });


